import { render, staticRenderFns } from "./DosageFormTem.vue?vue&type=template&id=69dac36b&scoped=true"
import script from "./DosageFormTem.vue?vue&type=script&lang=js"
export * from "./DosageFormTem.vue?vue&type=script&lang=js"
import style0 from "./DosageFormTem.vue?vue&type=style&index=0&id=69dac36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dac36b",
  null
  
)

export default component.exports